// 默认占位图：商品/SKU 无图时由展示层兜底使用（静态资源，不写入数据库）。
// 放在 admin-web/public/no_image.png，构建时会随 static 资源输出，
// 运行时由 BASE_URL 拼接为 /no_image.png 直接引用（与后端 public/no_image.png 同源拷贝）。
export const DEFAULT_NO_IMAGE = (process.env.BASE_URL || '/') + 'no_image.png'
